var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.hasResults)?_c('div',{staticClass:"container race-detail--wrapper"},[_c('Classifica',{attrs:{"data":_vm.data}})],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }